<script setup lang="ts">
import {  ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { useAuthStore } from '@/stores/useAuthStore'
import DatePicker from "../../Shared/DatePicker.vue"
import SsnInput from '../../Shared/SSNInput.vue'



const { t } = useI18n()
const { umsokn, onLoaded } = useUmsokn()
const authStore = useAuthStore()

const props = defineProps<{ disable?: boolean }>()
const deathDateMenu = ref(false)

const rules = {
  umsokn: {
    sjodsfelagiName: { required },
    sjodsfelagiSsn: { required },
    sjodsFelagiDeath: { required },
    elliOrOrorku: { required }
  }
}
const v$ = useVuelidate(rules, { umsokn })

onLoaded(async () => {
  try {
    const user = await authStore.getAuthUser()
    if (user && umsokn.value) {
      umsokn.value.name = user.name
      umsokn.value.ssn = user.username
    }
  } catch (e) {
    console.error('Auth prefill failed', e)
  }
})

function digitsOnly(v: string) {
  return (v || '').replace(/\D/g, '')
}

// --- Date helpers ---
function todayISO() {
  return new Date().toISOString().split('T')[0]
}

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <v-row v-if="umsokn">
    <v-col cols="12">
      <h2 class="form__header">
        {{ t('makalifeyrir_umsokn_step2_header') }}
      </h2>
    </v-col>

    <!-- Name -->
    <v-col cols="12" md="6">
      <v-text-field
        v-model="umsokn.sjodsfelagiName"
        :label="t('makalifeyrir_umsokn_step2_nafn')"
        variant="outlined"
        :readonly="props.disable"
        :error="v$.umsokn.sjodsfelagiName.$error"
        :error-messages="v$.umsokn.sjodsfelagiName.$error ? [t('makalifeyrir_umsokn_step2_nafn_error')] : []"
      />
    </v-col>

    <!-- SSN -->
    <v-col cols="12" md="6">
      <SsnInput
        v-model="umsokn.sjodsfelagiSsn"
        :label="t('makalifeyrir_umsokn_step2_ssn')"
        variant="outlined"
        :readonly="props.disable"
        :error="v$.umsokn.sjodsfelagiSsn.$error"
        :error-messages="v$.umsokn.sjodsfelagiSsn.$error ? [t('makalifeyrir_umsokn_step2_ssn_error')] : []"
      />
    </v-col>

    <!-- Death date -->
    <v-col cols="12" md="6">
      <DatePicker
      v-model="umsokn.sjodsFelagiDeath"
      :label="t('makalifeyrir_umsokn_step2_danardagur')"
      :disabled="props.disable"
      :error="v$.umsokn.sjodsFelagiDeath.$error"
      :error-messages="v$.umsokn.sjodsFelagiDeath.$error
        ? [t('makalifeyrir_umsokn_step2_danardagur_error')]
        : []"
    />
      
      <div v-if="v$.umsokn.sjodsFelagiDeath.$error" class="error__text">
        {{ t('makalifeyrir_umsokn_step2_danardagur_error') }}
      </div>
    </v-col>

    <!-- Radio -->
    <v-col cols="12">
      <p>{{ t('makalifeyrir_umsokn_step2_sjodfelagi') }}</p>
      <v-radio-group
        v-model="umsokn.elliOrOrorku"
        inline
        hide-details
        :readonly="props.disable"
        :error="v$.umsokn.elliOrOrorku.$error"
        :error-messages="v$.umsokn.elliOrOrorku.$error ? [t('makalifeyrir_umsokn_step2_sjodfelagi_error')] : []"
      >
        <v-radio :label="t('makalifeyrir_umsokn_step2_sjodfelagi_yes')" :value="1" />
        <v-radio :label="t('makalifeyrir_umsokn_step2_sjodfelagi_no')" :value="2" />
      </v-radio-group>
    </v-col>
  </v-row>
</template>
